import login from './login'
import logout from './logout'
import invite from './invite'
import { passwordReset, passwordResetWithToken } from './passwordReset'
import ssoLogin from './ssoLogin'
import getPasswordFormat from './getPasswordFormat'

export default {
  login,
  invite,
  passwordReset,
  passwordResetWithToken,
  ssoLogin,
  getPasswordFormat,
  logout,
}
